import { render, staticRenderFns } from "./Gallery1.vue?vue&type=template&id=4fbf914e&scoped=true&"
import script from "./Gallery1.vue?vue&type=script&lang=js&"
export * from "./Gallery1.vue?vue&type=script&lang=js&"
import style0 from "./Gallery1.vue?vue&type=style&index=0&id=4fbf914e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf914e",
  null
  
)

export default component.exports